import Stack from '@mui/material/Stack';

import TextInput from 'components/FormInputs/TextInput';
import PasswordRequirements from 'components/PasswordRequirements';

export function PasswordStep() {
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-around" gap={2}>
      <Stack gap={2} flexGrow={1}>
        <TextInput name="email" label="Student Email" disabled helperText="You will login with the student's email" />
        <TextInput name="password" label="Password" type="password" />
      </Stack>
      <PasswordRequirements
        fieldName="password"
        requirements={[
          {
            title: 'Contains at least one digit (0-9)',
            regex: /(?=.*[0-9])/,
          },
          {
            title: 'Contains at least one special character from the set (![!@#$%^&*])',
            regex: /(?=.*[!@#$%^&*])/,
          },
          {
            title: 'Contains at least one lowercase letter (a-z)',
            regex: /(?=.*[a-z])/,
          },
          {
            title: 'Contains at least one uppercase letter (A-Z)',
            regex: /(?=.*[A-Z])/,
          },
          {
            title: 'Is at least 8 characters long',
            regex: /.{8,}/,
          },
        ]}
      />
    </Stack>
  );
}
